/**
 * For $.ajax requests
 * csrfCookieGP is always send
 * If cookie is expired show spop and throw error
 * @example
	$('#select-element').on('change', function(ev) {
		var _this = $(this);
		if (!_this.val()) return;

		var data = '&val=' + _this.val();

		$_GP.ajax('url/to/endpoint', data, 'html').done(function(resp) {
			// request succeded
		}).fail(function() {
			// request fail
		}).always(function() {
			// request end
		});
	});
 * @param {string} url - endpoint, $.ajax url
 * @param {string|object|null} data - $.ajax data
 * @param {string} [dataType='json'] - $.ajax dataType
 * @param {string} [type='POST'] - $.ajax type
 * @returns {object} $.ajax request
 * @requires $_GP._.is
 * @requires js.cookie-2.1.2-min.js
 * @requires spop-0.1.2.min.js
 */
$_GP.ajax = function( url, data, dataType, type) {
	if (!url) throw new Error('"url" is required!');

	dataType = dataType || 'json';
	type = type || 'POST';


	const cookieValue = Cookies.get('csrfCookieGP');

	const ignoreCsrf = $_GP.CSRF_EXCLUDE.some((v)=> v === url)

	if (!ignoreCsrf && !cookieValue) {
		spop({ template: $_GP.msm.submitCookieExpired, style: 'error', group: 'submitCookieExpired'});
		throw new Error('Cookie Expired!');
	}

	$('input[name="csrfTokenGP"]').val(cookieValue);

	if ($_GP._.is('string', data)) {
		if (!ignoreCsrf) data = data + '&csrfTokenGP=' + cookieValue;
	} else if ($_GP._.is('object', data)) {
		if (!ignoreCsrf) data.csrfTokenGP = cookieValue;
	} else if ($_GP._.is('null', data)) {
		if (!ignoreCsrf) data = '&csrfTokenGP=' + cookieValue;
	} else {
		throw new Error('Invalid "data"!. String, object or null');
	}

	return $.ajax({
		url:      url,
		data:     data,
		dataType: dataType,
		type:     type
	});
};
